import $ from 'jquery';

export default function lightbox() {
    $('.video-popup').magnificPopup({
        type: 'iframe',
        iframe: {
            patterns: {
                youtube: {
                    // Stop related videos from appearing at the end of the video player
                    src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0&showinfo=0'
                }
            }
        }
    });
}
